// extracted by mini-css-extract-plugin
export default {"label":"FormSelect_label__CHJwb"};